module.exports = __webpack_public_path__ + "team-efficiency.2H8ZpWG7.svg";